<template>
  <v-layout row justify-center>
    <v-btn
      flat
      class="chip-action-btn white--text"
      color="orange"
      @click="$router.push({name: 'SubscriptionSettings'})"
      v-tooltip.top-center="{
        content: 'Please upgrade your package',
        trigger: $store.state.metadata.windowWidth > 600 ? 'hover' : 'click'
      }"
    >
      <v-chip class="custom-action-chip small-upgrade-btn" label text-color="white" color="warning">
        <v-icon>open_in_browser</v-icon> Upgrade
      </v-chip>
    </v-btn>
  </v-layout>
</template>

<script>
export default {
  name: 'UpgradeSmallBtn',
  props: [],
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/buttons/UpgradeSmallBtn.vue